import React from 'react';
import { Routes, Route } from 'react-router-dom';
import FormList from './FormList';
import FormBuilder from './FormBuilder';
import FormPreview from './FormPreview';

const Forms: React.FC = () => {
  return (
    <Routes>
      <Route index element={<FormList />} />
      <Route path="new" element={<FormBuilder />} />
      <Route path=":id/edit" element={<FormBuilder />} />
      <Route path=":id/preview" element={<FormPreview />} />
    </Routes>
  );
};

export default Forms;